module.exports = __webpack_public_path__ + "static/media/Vast-Shadow.1380f0ea.svg";